import angular from "angular"
import { getDefaultWeight, weightFunctions, fullWeightFunctions } from "../counter-label"

angular.module("uCountitUiApp").controller("weightInputCtrl", ($scope) => {
  if (!$scope.weight) $scope.weight = getDefaultWeight()
  if (!$scope.mode) $scope.mode = "normal"

  $scope.WFs = $scope.mode === "full" ? fullWeightFunctions : weightFunctions
  $scope.function = {
    list: $scope.WFs,
    selected: $scope.WFs.find((f) => f.function === $scope.weight.function) || $scope.WFs[0],
  }

  $scope.strParams = $scope.function.selected.paramsToString($scope.weight.params)

  $scope.$watch("function.selected", (newFunc) => {
    $scope.weight.function = newFunc.function
  })

  $scope.$watch("strParams", (strParams) => {
    $scope.weight.params = $scope.function.selected.stringToParams(strParams)
  })
})
